/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Updateerror2Inputs */

const en_datagrid_updateerror2 = /** @type {(inputs: Datagrid_Updateerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update value. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update value. Please try again." |
*
* @param {Datagrid_Updateerror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_updateerror2 = /** @type {((inputs?: Datagrid_Updateerror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Updateerror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_updateerror2(inputs)
});
export { datagrid_updateerror2 as "dataGrid_updateError" }